import { ucmsConstants, apiPath } from '../constants';
import { deriveUrl } from './generic';
import PCSC from './pcsc';
import UCMS from './ucms';

// Mirrors VscCreationSelection's identifyDevices: connect, read the ATR, and
// run the UCMS "identify" APDU action. A per-reader failure (sharing violation,
// unsupported card, disconnect race, etc.) is allowed to propagate on purpose:
// resolveTargetReader catches it, keeps scanning the remaining readers, and --
// if nothing matches -- surfaces it rather than reporting a definitive
// "not on this endpoint" it could not actually confirm.
export async function identifyReader(reader) {
    let connection;
    try {
        connection = await PCSC.connect(reader, false);
        const { atr } = await connection.info();
        const result = await UCMS.apdu.run(
            connection,
            ucmsConstants.actions.identify,
            atr,
            () => {},
            deriveUrl(apiPath),
        );
        return (result && result.entries && result.entries[0] && result.entries[0].result) || {};
    } finally {
        if (connection) {
            try {
                await connection.disconnect();
            } catch (e) {
                // ignore: best-effort cleanup
            }
        }
    }
}
